// extracted by mini-css-extract-plugin
export default {"modal":"Cwzu8Q9R7jIbSw0gLOX0","closed":"pNv0cP3a4WbJRkHo063Y"};